export default __webpack_public_path__ + "static/media/drinkWater.7de173d7.gif";